"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoRooms/List/DesktopMeetingsFilterTooltip.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _Tooltip = require('web/components/Tooltip');












const DesktopFilterTooltipWrapper = ({
  isOpen, onClose, domTarget,
  onChange, inputId,
  activeOption, options,
}) => (
  _react2.default.createElement(_Tooltip.ControlledTooltip, {
    isOpen: isOpen,
    onClose: onClose,
    type: "light",
    place: "bottom",
    domTarget: domTarget,
    content: 
      _react2.default.createElement(_Tooltip.TooltipContent, { className: "meetings-list--filter-tooltip--content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
        , 
          options.map(({ value, label }) => (
            _react2.default.createElement('span', {
              key: value,
              onClick: () => { onChange(inputId, value); onClose() },
              className: _classBuilder2.default.call(void 0, 
                "meetings-list--filter-tooltip--option",
                { active: activeOption === value },
              ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}

              ,  label 
            )
          ))
        
      )
    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}
  )
)

exports. default = DesktopFilterTooltipWrapper
